export const locales = {
  vi: {
    close: 'Đóng',
    placeholder: 'Tìm kiếm địa chỉ',
    frequently_used: 'Thường được sử dụng',
    no_results: 'Không tìm thấy kết quả',
    current_location: 'Vị trí hiện tại',
    use_current_location: 'Lấy vị trí hiện tại',
    getting_current_location: 'Đang lấy vị trí hiện tại',
    error_permission_denied: 'Vui lòng cấp quyền để sử dụng tính năng',
    error_get_current_location: 'Không lấy được vị trí hiện tại',
    error_timeout_expired: 'Hiện ko kết nối được với internet',
    checking_location: 'Đang kiểm tra vị trí hiện tại',
    detect_location: 'Kiểm tra vị trí',
    required_api_url: 'apiURL là bắt buộc',
    required_api_key: 'apiKey là bắt buộc',
    choose_from_map: 'Chọn từ bản đồ',
    where_do_you_send: 'Bạn muốn giao hàng đến đâu?',
    where_do_you_want_to_pickup: 'Bạn muốn lấy hàng ở đâu?',
    save_places: 'Địa điểm đã lưu',
    save_place_sub: 'Lưu điểm thân quen của bạn',
    see_all: 'Xem tất cả',
    add_new: 'Thêm mới',
    new_save_place: 'Thêm địa điểm thân quen',
    delivery_point: 'Điểm giao hàng',
    address: 'Địa chỉ',
    place_name: 'Tên địa điểm',
    address_detail: 'Chi tiết địa chỉ',
    contact_name: 'Tên liên lạc',
    contact_number: 'Số điện thoại',
    place_name_des: 'Ví dụ: Nhà, Công ty',
    address_detail_des: 'Ví dụ: Số tầng, Số căn hộ (Không bắt buộc)',
    contact_name_des: 'Nhập tên người liên lạc (Không bắt buộc)',
    contact_number_des: 'Nhập số điện thoại liên lạc (Không bắt buộc)',
    submit_place: 'Lưu địa điểm',
    submit: 'Xác nhận',
    error_format_mobile: 'Số điện thoại không hợp lệ',
    error_choose_address: 'Cẩn lựa chọn địa chỉ',
    error_name_alias_required: 'Cần tên địa điểm',
    error_name_alias_length: 'Tên địa điểm cần 1 ký tự',
    no_map_title: 'Chưa thể tải bản đồ vị trí của bạn',
    no_map_description: 'Hãy nhập địa điểm lấy hàng để xem bản đồ',
    point: 'Điểm',
  },
  en: {
    close: 'Close',
    placeholder: 'Search address',
    frequently_used: 'Frequently used',
    no_results: 'No results found',
    current_location: 'Current location',
    use_current_location: 'Use current location',
    getting_current_location: 'Getting current location',
    error_permission_denied: 'Please allow geo permission to use',
    error_get_current_location: 'Cannot get current location',
    error_timeout_expired: 'Cannot connect to internet',
    checking_location: 'Checking current location',
    detect_location: 'Detect location',
    required_api_url: 'apiURL is required',
    required_api_key: 'apiKey is required',
    choose_from_map: 'Choose from map',
    where_do_you_send: 'Where do we send your items?',
    where_do_you_want_to_pickup: 'Where do we pickup your items?',
    find_address: 'Find address',
    save_places: 'Saved places',
    save_place_sub: 'Saved your favorite place ',
    see_all: 'See all',
    add_new: 'Add new',
    new_save_place: 'New save place address',
    delivery_point: 'Delivery point',
    address: 'Address',
    place_name: 'Place name',
    address_detail: 'Address detail',
    contact_name: 'Contact name',
    contact_number: 'Contact number',
    place_name_des: 'Example: Home, company',
    address_detail_des: 'Example: Floor (Optional)',
    contact_name_des: 'Contact name (Optional)',
    contact_number_des: 'Contact number (Optional)',
    submit_place: 'Save place',
    submit: 'Submit',
    error_format_mobile: 'Invalid mobile number',
    error_choose_address: 'Please choose address',
    error_name_alias_required: 'Please name a location',
    error_name_alias_length: 'Please name at least 1 characters',
    no_map_title: 'Can not load map of your location',
    no_map_description: 'Please input Pick-up Location to see the map',
    point: 'Point',
  },
};

export type Locales = Record<string, Record<string, string>>;
